// The legal pages (/privacy, /terms, /acceptable-use, /voice-likeness, /copyright, /ai-content, /refunds), for the app
// to mount (App.tsx):
//   const page = legalScreen(path, { isPublic: legalPagesPublic(config), role: me?.user.role });
//   if (page) return <LegalScreen page={page} />;
// LegalScreen is lazy so the legal text never ships in the landing or app chunks.
import { createElement, lazy } from "react";
import type { LegalPage as Page } from "./guard";

export { canSeeLegal, CHECKOUT_NOTE, LEGAL_LINKS, legalPageFor, legalPagesPublic, legalScreen, type LegalAccess, type LegalPage } from "./guard";

const Doc = lazy(() => import("./Doc"));

/** The page for `page`, lazily loaded; wrap it in <Suspense>. */
export function LegalScreen({ page }: { page: Page }) {
  return createElement(Doc, { page });
}
